import getCSSVariableValue from './getCSSVariableValue';

export { getCSSVariableValue };
